<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="dedication" role="doc-dedication">
<p class="LINESPACE" id="ded"> </p>
<p class="DED"><span aria-label="vii" id="pg_vii" role="doc-pagebreak"><i>To my daughter, Michelle, who went with me to Texas Motor Speedway. You are always in my corner no matter what—even if you have to get up at 5 a.m.</i></span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?230f8e0b